import React, { useState, useEffect } from 'react';
/* 🎯 HANDSHAKE: Standardized API wrapper with fixed relative path */
import { dbPayload } from "../../../../auth/registered/SEC_00_DB_Payload"; 
/* 🎯 NORMALIZATION: Fixed path to reach ../../../../app/ standards */
import { GoldenSourceHelper } from "../../../../app/Switch_Core_React_Standards";
/* 🎯 MVC: PascalCase View Alias */
import SEC03CapabilityView from './SEC_03_CapabilityManagementView';
/* 🎯 VALIDATOR: Exact name from your SEC_03_CapabilityManagementValidator.js */
import { SEC_03_CapabilityManagementValidator } from './SEC_03_CapabilityManagementValidator';
/* 🎯 MODEL: Mapping row from your UserManagement domains */
import { SEC_03_initialCapabilityRow } from '../../../domains/SEC_03_Usermanagement/SEC_03_CapabilityModels';

const SEC_03_CapabilityManagementController = () => {
    // 🎯 Only keeping the state necessary for the siloed Capabilities list
    const [capabilities, setCapabilities] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadInitialData = async () => {
            console.log("🚀 SEC_03: Starting Isolated Capability Load...");
            try {
                const siteKey = process.env.REACT_APP_SITE_KEY;

                // 🛰️ 1. HANDSHAKE: Fetching ONLY the capability dictionary.
                const capRes = await dbPayload('/api/v1/sustina/manage-users/capability-dictionary', 'POST', siteKey, {});

                console.log("📦 RAW GATEWAY DATA:", { capRes });

                // ====================================================================
                // 🧠 POC STEP 2: METADATA INTERCEPTION & LOGGING
                // ====================================================================
                if (capRes && capRes.metadata) {
                    console.log("=================================================");
                    console.log("🧠 DYNAMIC SCHEMA DISCOVERED FROM C# BACKEND!");
                    console.log("Primary Key:", capRes.metadata.primaryKey);
                    console.table(capRes.metadata.columns); // 🎯 Renders a clean table in the browser console
                    console.log("=================================================");
                } else {
                    console.log("⚠️ No metadata detected in the C# response.");
                }
                // ====================================================================

                // 🎯 2. NORMALIZATION: Extracting the "data" array
                const caps = GoldenSourceHelper.normalize(capRes);

                // 🎯 3. PROCESSING: Mapping response to local state
                if (caps.success && Array.isArray(caps.data)) {
                    // Force the UI state to 'false' so the default action is "Display"
                    const hiddenInitialState = caps.data.map(cap => ({
                        ...cap,
                        isActive: false 
                    }));
                    setCapabilities(hiddenInitialState); 
                } else {
                    console.warn("⚠️ DATA WARNING: Capabilities normalization failed.", caps);
                }

            } catch (err) {
                console.error("❌ CRITICAL SYNC ERROR:", {
                    message: err.message,
                    stack: err.stack
                });
            } finally {
                // 🏁 TERMINATION: Break the "Synchronizing" loop
                console.log("🏁 SEC_03: Sync Attempt Complete.");
                setLoading(false);
            }
        };
        loadInitialData();
    }, []);

    /**
     * 🎯 ISOLATED CAPABILITY LOGIC
     */
    const handleCapabilityUpdate = async (capabilityId, updatedData) => {
        const updatedRow = {
            ...SEC_03_initialCapabilityRow,
            ...updatedData,
            capabilityId: capabilityId
        };

        /* 🎯 VALIDATOR: Ensure the flat capability data is valid */
        if (SEC_03_CapabilityManagementValidator(updatedRow)) {
            console.log("Saving Capability update:", updatedRow);
            
            // Optimistic UI Update for the flat list
            setCapabilities(prev => 
                prev.map(cap => cap.capabilityId === capabilityId ? { ...cap, ...updatedData } : cap)
            );
        }
    };

    // Add function handler to satisfy the View's onAdd prop
    const handleCapabilityAdd = (newRow) => {
        console.log("Adding new capability:", newRow);
        // Note: You will eventually pass this through your Validator and dbPayload
        setCapabilities(prev => [...prev, newRow]);
    };

    if (loading) return <div className="p-4 small text-muted italic">Loading Capabilities List...</div>;

    return (
        <SEC03CapabilityView 
            capabilities={capabilities} 
            onUpdate={handleCapabilityUpdate} 
            onAdd={handleCapabilityAdd}
        />
    );
};

export default SEC_03_CapabilityManagementController;